import { ProductId } from 'src/replicant/iap/iap.ruleset';
import { duration } from 'src/replicant/utils/duration';
import { Match2Reward } from '../rewards/match2-rewards.ruleset';
import {
  PetStarterPackProductId,
  petStarterPackProducts,
  petStarterPacks,
} from 'src/replicant/starterpack/starterpack.ruleset';

type TagType =
  | 'sale'
  | 'mostPopular'
  | 'bestValue'
  | 'hidden'
  | 'starterPackPromo';

/**
 * Bundle pack interface
 */
export interface ShopBundlePack {
  tag?: TagType;
  rewards: Match2Reward[];
  fixedPrice?: number; // Fixed price in JPY, for promo products only
}

/**
 * Packs of rewards per product id, excluding free and paid gems, which are set in iap.ruleset already
 */
export const shopBundlesPacks: Record<string, ShopBundlePack> = {
  buruburu_starter_pack: {
    tag: 'sale',
    rewards: [
      { type: 'wrapper', id: 'all_powerups', amount: 1 },
      { type: 'wrapper', id: 'all_boosters', amount: 1 },
    ],
  },
  buruburu_mini_pack: {
    rewards: [
      { type: 'wrapper', id: 'all_powerups', amount: 1 },
      { type: 'wrapper', id: 'all_boosters', amount: 1 },
    ],
  },
  buruburu_small_pack: {
    rewards: [
      { type: 'wrapper', id: 'all_powerups', amount: 2 },
      { type: 'wrapper', id: 'all_boosters', amount: 2 },
    ],
  },
  buruburu_medium_pack: {
    tag: 'mostPopular',
    rewards: [
      { type: 'energy', duration: duration({ hours: 2 }) },
      { type: 'wrapper', id: 'all_powerups', amount: 4 },
      { type: 'wrapper', id: 'all_boosters', amount: 4 },
    ],
  },
  buruburu_large_pack: {
    rewards: [
      { type: 'energy', duration: duration({ hours: 6 }) },
      { type: 'wrapper', id: 'all_powerups', amount: 8 },
      { type: 'wrapper', id: 'all_boosters', amount: 8 },
    ],
  },
  buruburu_grande_pack: {
    rewards: [
      { type: 'energy', duration: duration({ hours: 12 }) },
      { type: 'wrapper', id: 'all_powerups', amount: 18 },
      { type: 'wrapper', id: 'all_boosters', amount: 18 },
    ],
  },
  buruburu_jumbo_pack: {
    tag: 'bestValue',
    rewards: [
      { type: 'energy', duration: duration({ hours: 18 }) },
      { type: 'wrapper', id: 'all_powerups', amount: 25 },
      { type: 'wrapper', id: 'all_boosters', amount: 25 },
    ],
  },

  // Append pet starter packs to the product list
  ...petStarterPacks,
};

export const upsellPacks: ProductId[] = [
  'buruburu_mini_pack',
  'buruburu_small_pack',
  'buruburu_medium_pack',
  'buruburu_large_pack',
  'buruburu_grande_pack',
  'buruburu_jumbo_pack',
];
/**
 * List of all available products in bundles shop
 */
export const shopBundlesAvailableProducts: ProductId[] = [
  'buruburu_starter_pack',

  ...upsellPacks,

  'buruburu_gems_200',
  'buruburu_gems_1000_1200',
  'buruburu_gems_2000',
  'buruburu_gems_5500',
  'buruburu_gems_10000',
  'buruburu_gems_20000',

  // Append pet starter pack products to the list
  ...petStarterPackProducts,
];

/**
 * Starter pack product id
 */
export type StarterPackProductId =
  | PetStarterPackProductId
  | 'buruburu_starter_pack';
